import consumer from "./consumer"

const App = {}
App.cable = consumer

App.chat = App.cable.subscriptions.create("ChatChannel", {
  connected: function() {
    // Called when the subscription is ready for use on the server
  },
  disconnected: function() {
    // Called when the subscription has been terminated by the server
  },
  received: function(data) {
    let currentUserId = parseInt($("#current_user_id").val());
    let isCurrentUser = currentUserId === data["user_id"];
    let sentence;
    
    if (isCurrentUser){
      sentence=`<div class='mycomment'><p>${data["sentence"]}</p></div><p class="mycomment-time">${data["user_nickname"]}</p><p class="mycomment-time">${data["message_time"]}</p>`;
    }
    else{
      let userIcon = data["user_icon"];
      if (userIcon === null){
        userIcon = "https://drivemate2023.s3.ap-northeast-1.amazonaws.com/uploads/user/user_default.png";
      }
  
      sentence=`<div class='fukidasi'><div class='faceicon'>
      <img src="${userIcon}" class="spot-map-review-icon" alt="User picture"></div>
      <div class='chatting'><div class='says'><p>${data["sentence"]}</p></div><p class="chatting-time">${data["user_nickname"]}</p><p class="chatting-time">${data["message_time"]}</p></div>`;
    }
    $('#chats').append(sentence);
  },
  speak: function(sentence) {
    let user_id = $("#current_user_id").val();
    // let partner_id = $("#partner_id").val();
    let touring_group_id = $("#touring_group_id").val();
    return this.perform('speak',{sentence: sentence, user_id: user_id, touring_group_id: touring_group_id});
  }
});


document.addEventListener('turbolinks:load', function() {
  $(function(){
    $("#send").on("click",function(e){
      let sentence=$("#sentence").val();
      App.chat.speak(sentence);
      $("#sentence").val(""); //フォームを空に
      e.preventDefault();
    });
  });
});
